import { render, staticRenderFns } from "./materialAdd.vue?vue&type=template&id=08cbc1cd&scoped=true"
import script from "./materialAdd.vue?vue&type=script&lang=js"
export * from "./materialAdd.vue?vue&type=script&lang=js"
import style0 from "./materialAdd.vue?vue&type=style&index=0&id=08cbc1cd&prod&rel=stylesheet%2Fscss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbc1cd",
  null
  
)

export default component.exports